import apiClient from "./client";

export const getBlogPosts = async ({ language = "en" } = {}) => {
  const response = await apiClient.get("/blog", {
    params: { language },
  });
  return response.data;
};
